import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { getToken } from '.';
import { v4 as uuidv4 } from 'uuid';

// Create a new instance of the Client using the BFF Url
export function createApolloClient(bffUrl: string): ApolloClient<any> {
  const httpLink = createHttpLink({
    uri: bffUrl,
    credentials: 'include'
  });

  // Sets the Context for the ApolloClient, this function will
  // be called everytime a request is made so getting the Auth Token
  // this way will allow it to always be up to date
  const authLink = setContext((_, { headers }) => {
    const token = getToken()?.accessToken;
    const xCorrelationId = uuidv4();

    return {
      headers: {
        ...headers,
        authorization: token ? `Bearer ${token}` : '',
        'x-correlation-id': xCorrelationId
      }
    };
  });

  const client = new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache(),
    credentials: 'include'
  });

  return client;
}
